import {
  DialogDescription,
  DialogContent,
  DialogTrigger,
  DialogFooter,
  DialogHeader,
  DialogClose,
  DialogTitle,
  Button,
  Dialog,
} from '@ui/components';
import { useTranslation } from 'react-i18next';
import { PropsWithChildren, FC } from 'react';

interface CostCenterRemoveCardDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onRemove: () => void;
}

export const CostCenterRemoveCardDialog: FC<PropsWithChildren<CostCenterRemoveCardDialogProps>> = ({
  open,
  onOpenChange,
  children,
  onRemove,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog onOpenChange={onOpenChange} open={open}>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('COST_CENTER.ACCOUNT_DETAILS.REMOVE_CARD_DIALOG.TITLE')}</DialogTitle>
        </DialogHeader>
        <DialogDescription>
          {t('COST_CENTER.ACCOUNT_DETAILS.REMOVE_CARD_DIALOG.DESCRIPTION')}
        </DialogDescription>
        <DialogFooter>
          <DialogClose asChild>
            <Button onClick={() => onOpenChange(false)} variant="tertiary" wide>
              {t('COST_CENTER.ACCOUNT_DETAILS.REMOVE_CARD_DIALOG.CANCEL')}
            </Button>
          </DialogClose>
          <Button
            onClick={() => {
              onRemove();
              onOpenChange(false);
            }}
            variant="primary"
            wide
          >
            {t('COST_CENTER.ACCOUNT_DETAILS.REMOVE_CARD_DIALOG.REMOVE')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
